import React from 'react';
import Modal from 'antd/lib/modal/Modal';
import { Row, Space } from 'antd';
import { WarningFilled } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';
import { RBHBox, RBHButton } from '../../../../../shared/components';

import styles from './styles';
import './stylescss.css';

// All four texts are message ids, not literal copy.
interface ConfirmDialogProps {
  title: string;
  message: string;
  visible: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  confirmText?: string;
  cancelText?: string;
  disabled?: boolean;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  title,
  message,
  visible,
  onConfirm,
  onCancel,
  confirmText = 'main.branchform.confirm.submit',
  cancelText = 'main.branchform.confirm.back',
  disabled = false,
}) => {
  return (
    <Modal
      className='confirm-dialog'
      centered={true}
      closable={false}
      visible={visible}
      width={480}
      footer={null}
    >
      <RBHBox style={styles.confirmDialogBox}>
        <RBHBox style={styles.confirmDialogContent}>
          <Space size={8} align='start'>
            <WarningFilled translate={null} style={styles.confirmDialogIcon} />
            <RBHBox
              data-testid={'confirm_dialog_title'}
              id={'confirm_dialog_title'}
              style={styles.confirmDialogTitle}
            >
              <FormattedMessage id={title} />
            </RBHBox>
          </Space>
          <RBHBox
            data-testid={'confirm_dialog_message'}
            id={'confirm_dialog_message'}
            style={styles.confirmDialogMessage}
          >
            <FormattedMessage id={message} />
          </RBHBox>
        </RBHBox>
        <Row style={styles.confirmDialogFooter} justify='end' align='middle'>
          <Space size={8}>
            <RBHButton
              data-testid={'confirm_dialog_cancel'}
              id={'confirm_dialog_cancel'}
              style={styles.confirmDialogCancelButton}
              onClick={onCancel}
              text={cancelText}
            />
            <RBHButton
              data-testid={'confirm_dialog_confirm'}
              id={'confirm_dialog_confirm'}
              style={styles.confirmDialogConfirmButton}
              disabled={disabled}
              onClick={onConfirm}
              text={confirmText}
            />
          </Space>
        </Row>
      </RBHBox>
    </Modal>
  );
};

export default ConfirmDialog;
